module.exports = __webpack_public_path__ + "static/media/developers.2d821710.png";